const useGetRetinalExamDataModelConfig = () => {
  return {
    deviceDataModelId: import.meta.env.VITE_DEVICE_MODEL_ID,
    examSubmissionPropertySetId: import.meta.env
      .VITE_DEVICE_PROPERTY_SET_ID_EXAM_SUBMISSION,
    examReportPropertySetId: import.meta.env
      .VITE_DEVICE_PROPERTY_SET_ID_EXAM_REPORT,
    followupPropertySetId: import.meta.env.VITE_DEVICE_PROPERTY_SET_ID_FOLLOWUP,
  };
};

export default useGetRetinalExamDataModelConfig;
